jQuery.ajax({
    url: 'https://api.ipdata.co?api-key=707d6b4c1028c1a7659278a928ac17764a3e7c232b2745974ea253e5',
    type: 'GET',
    dataType: 'json',
    success: function (location) {
  
      const userRegion = location.region;

      const userCountryName = location.country_name;

      jQuery('#country-name').html(userCountryName);
      jQuery('#country-name-product').html(userCountryName);
      jQuery('#country-name-product2').html(userCountryName);
      jQuery('#country-name-product3').html(userCountryName);
  
      if (userCountryName == "United States" && userRegion != "Alaska") {
        $(".topbarshipping").show();
        jQuery('.topbarlocation').html(userRegion);
        jQuery('#country-name').html(userRegion);
        jQuery('#country-name-product2').html(userRegion);
        jQuery('#country-name-product3').html(userRegion);
        $(".price__fordiscont").show();
        $(".progressbar__wrapper").show();
      }
  
      else if (userCountryName == "Canada") {
        $(".topbarshipping").show();
        jQuery('.topbarlocation').html(userRegion);
        jQuery('#country-name').html(userRegion);
        $(".price__fordiscont").show();
        $(".progressbar__wrapper").show();
      }
    },
    error: function () {
        console.error("Error fetching location data");
    }
  });

